/* eslint-disable */
import api from '@/services/api';

export default {
  async salvar({ dispatch }, payload) {
    const { _id } = payload;
    if (_id) {
      return await api.put(`/modeloRelatorio/${_id}`, payload)
        .then(() => dispatch('fetchModelos'));
    }

    return await api.post('/modeloRelatorio/', payload)
      .then(() => dispatch('fetchModelos'));
  },

  async delete({ dispatch }, payload) {
    return await api.delete(`/modeloRelatorio/${payload}`)
      .then(() => dispatch('fetchModelos'));
  },

  async fetchModelos({ commit }) {
    const response = await api.get('/modeloRelatorio/');
    commit('SET_MODELOS', response.data);
  },

  async fetchModelo({ commit }, payload) {
    const response = await api.get(`/modeloRelatorio/${payload}`);
    commit('SET_MODELO', response.data);
  },

  async setColunasDinamicas({ commit }, payload) {
    commit('SET_COLUNAS_DINAMICAS', payload);
  },

  limparColunas({ commit }) {
    commit('LIMPAR_COLUNAS');
  },
};
